import styled from "styled-components";

import { theme } from "@components/variables";
import { Heading as HeadingCore } from "@components/heading";

export const Wrapper = styled.div`
  margin-top: 20px;
  padding: 10px 0;
  border-top: 1px solid ${theme.borderColor};
`;

export const Heading = styled(HeadingCore)`
  margin-bottom: 20px;
`;

export const UploadItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  border-bottom: 1px solid ${theme.borderColor};
  padding: 4px;
`;

export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;

export const CheckboxLabel = styled.span`
  display: inline-block;
  margin-right: 10px;
`;

export const TagsWrapper = styled.div`
  flex: 1;
`;

export const NewTagForm = styled.form`
  display: inline-flex;
  align-items: baseline;
  margin-right: 20px;
`;

export const SortOrder = styled.span`
  color: ${theme.primaryColor};
  font-weight: bold;
  margin-right: 5px;
`;
